import { render, staticRenderFns } from "./Blood.vue?vue&type=template&id=250f4efc&scoped=true&"
import script from "./Blood.vue?vue&type=script&lang=js&"
export * from "./Blood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250f4efc",
  null
  
)

export default component.exports